import { SCRIPT_ROLE_COLUMN_INDEX } from "./feishuScriptSheet";

/** 飞书 sheet merges 条目（0-based 行列索引，含 end） */
export interface FeishuMergeRange {
  startRowIndex: number;
  endRowIndex: number;
  startColumnIndex: number;
  endColumnIndex: number;
}

export interface FeishuMergeRangeApi {
  start_row_index: number;
  end_row_index: number;
  start_column_index: number;
  end_column_index: number;
}

export function normalizeFeishuMergeRanges(raw: unknown): FeishuMergeRange[] {
  if (!Array.isArray(raw)) return [];

  const ranges: FeishuMergeRange[] = [];
  for (const item of raw) {
    if (!item || typeof item !== "object") continue;
    const merge = item as Partial<FeishuMergeRangeApi>;
    if (
      typeof merge.start_row_index !== "number" ||
      typeof merge.end_row_index !== "number" ||
      typeof merge.start_column_index !== "number" ||
      typeof merge.end_column_index !== "number"
    ) {
      continue;
    }
    ranges.push({
      startRowIndex: merge.start_row_index,
      endRowIndex: merge.end_row_index,
      startColumnIndex: merge.start_column_index,
      endColumnIndex: merge.end_column_index,
    });
  }
  return ranges;
}

export function mergeRangeCoversCell(
  merge: FeishuMergeRange,
  rowIndex: number,
  columnIndex: number
): boolean {
  return (
    rowIndex >= merge.startRowIndex &&
    rowIndex <= merge.endRowIndex &&
    columnIndex >= merge.startColumnIndex &&
    columnIndex <= merge.endColumnIndex
  );
}

export function filterRoleColumnMerges(merges: FeishuMergeRange[]): FeishuMergeRange[] {
  return merges.filter((merge) =>
    mergeRangeCoversCell(merge, merge.startRowIndex, SCRIPT_ROLE_COLUMN_INDEX)
  );
}

/** 若 B 列处于合并区域，返回合并块左上角行索引 */
export function findRoleColumnMergeAnchorRow(
  merges: FeishuMergeRange[],
  rowIndex: number
): number | undefined {
  for (const merge of merges) {
    if (mergeRangeCoversCell(merge, rowIndex, SCRIPT_ROLE_COLUMN_INDEX)) {
      return merge.startRowIndex;
    }
  }
  return undefined;
}

export function isRoleColumnMergeInherited(
  merges: FeishuMergeRange[],
  rowIndex: number
): boolean {
  const anchor = findRoleColumnMergeAnchorRow(merges, rowIndex);
  return anchor !== undefined && anchor !== rowIndex;
}
